import { FormControl } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { ControlledRadioGroup, Fieldset } from '@components';

export const CreditScoreImportance = () => {
  const { t } = useTranslation('subModules/creditScoreImportance');
  const fields: { [key: string]: string } = t('fields', {
    returnObjects: true,
  }) as { [key: string]: string };

  return (
    <Fieldset label={t('label')} required>
      <FormControl component="fieldset">
        <ControlledRadioGroup
          name="creditScoreImportance"
          fields={fields}
          aria-labelledby="credit-score-importance-radio-buttons"
          data-testid="creditScoreImportanceSubModule"
          data-tf-sensitive="true"
        />
      </FormControl>
    </Fieldset>
  );
};
